/**
 * TabNav — underline tabs for the six Budgets and Contracts sections (plan
 * §11, R36; design skill "Tabs (underline)" recipe). Reads CONTRACTS_TABS so
 * the nav can never list a tab ContractsApp's routes don't also render.
 */
import { NavLink } from 'react-router-dom';
import { CONTRACTS_TABS } from '../tabs/config';

const tabCls = (active: boolean) =>
  `inline-flex min-h-[44px] items-center gap-1.5 whitespace-nowrap border-b-2 px-2.5 text-sm font-medium transition-colors duration-150 sm:min-h-0 sm:py-2 ${
    active
      ? 'border-primary-600 text-primary-700 dark:text-primary-400'
      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
  }`;

export function TabNav() {
  return (
    <nav
      className="flex gap-1 overflow-x-auto border-b border-gray-200 px-4 dark:border-gray-700 sm:px-6 lg:px-8"
      aria-label="Contracts sections"
    >
      {CONTRACTS_TABS.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink key={tab.key} to={`/contracts/${tab.path}`} className={({ isActive }) => tabCls(isActive)}>
            <Icon size={16} aria-hidden="true" />
            {tab.navLabel}
          </NavLink>
        );
      })}
    </nav>
  );
}

export default TabNav;
